module.exports = __webpack_public_path__ + "img/food.34d434d0.png";